<ng-template #template>
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'Error' | translate}}
    </h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modalRef.hide()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div>{{ Message | translate }}</div>
    <button type="button" class="btn btn-sm" (click)="okey()">
      {{'OK' | translate}}
    </button>
  </div>
</ng-template>
